import { appendLangCode } from './append-lang-code';
import { hasLangCodeParam } from './has-lang-code-param';

export const setLangCode = (url: string, langCode: string) => {
  if (!langCode) return url;
  if (langCode.length !== 2 && langCode.length !== 5) return url;
  if (hasLangCodeParam(url)) return url;
  return appendLangCode(url, langCode);
};
